{
    "user": "User",
    "passwordsDoNotMatch": "Passwords do not match.",
    "userSavedSuccessfully": "saved successfully.",
    "allFieldsRequired": "All fields are required.",
    "passwordMinLength": "Password must be at least 6 characters long.",
    "invalidEmailFormat": "Please enter a valid email address.",
    "checkingUsersDeletion": "Are you sure you want to delete the selected user?",
    "superUser": "Super User",
    "canChangePassword": "User May Change Password",
    "forcePasswordChange": "Change Password at Next Login",
    "Username": "User Name",
    "firstName": "First Name",
    "lastName": "Last Name",
    "email": "Email",
    "roles": "Roles",
    "confirmPassword": "Confirm Password",
    "roleName": "Role Name",
    "userDeleted": "User deleted successfully"
}